// iter273 — one-shot deep-link focus handoff.
//
// Cmd+K can't prop-drill "expand PO xyz" through Clients → WorkOrderTab →
// PurchaseOrders, and router state gets cleared by the customer sheet's
// history.replaceState before those sections mount. So the palette stashes
// the target id here and the section consumes it once, on load.
export const FOCUS_PO = "__focus_po_id";
export const FOCUS_CO = "__focus_co_id";
export const FOCUS_INVOICE = "__focus_invoice_id";
export const FOCUS_TECH = "__focus_tech_id";
export const FOCUS_TECH_DISPATCH = "__focus_tech_dispatch_id";
export const FOCUS_VENDOR = "__focus_vendor_id";

export function setFocusTarget(key, id) {
  try { sessionStorage.setItem(key, id); } catch { /* private mode */ }
}

// Read without clearing — used by parent panels that only need to know a
// deep-link is pending (e.g. switch to the right sub-tab).
export function peekFocusTarget(key) {
  try { return sessionStorage.getItem(key); } catch { return null; }
}

export function consumeFocusTarget(key) {
  try {
    const v = sessionStorage.getItem(key);
    if (v) sessionStorage.removeItem(key);
    return v;
  } catch {
    return null;
  }
}

export function scrollToTestId(testId) {
  // Sections animate open, so wait a tick before measuring.
  setTimeout(() => {
    const el = document.querySelector(`[data-testid="${testId}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, 250);
}
